// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "session".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "session" table (1:1 with a DB row, on the wire). */
export const sessionAtomSchema = z.object({
    id: z.string(),
    expiresAt: z.string().datetime(),
    token: z.string(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    ipAddress: z.string().nullable(),
    userAgent: z.string().nullable(),
    userId: z.string(),
    impersonatedBy: z.string().nullable(),
});
//# sourceMappingURL=session.js.map